exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-link-exact-active[data-v-9fd6a65c]{background-color:#fff;color:#000!important;border-bottom:5px solid #fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9fd6a65c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/frontEnd/AritcleDetail.vue
// module id = 253
// module chunks = 0